/* global axios */
import ApiClient from './ApiClient';

class RealEstateFinanceAPI extends ApiClient {
  constructor() {
    super('real_estate_finance', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  statusCatalog() {
    return axios.get(`${this.url}/status_catalog`);
  }

  filterCatalog() {
    return axios.get(`${this.url}/filter_catalog`);
  }

  transition(id, payload) {
    return axios.post(`${this.url}/${id}/transition`, payload);
  }

  updatePaymentResponsibilities(id, responsibilities) {
    return axios.patch(`${this.url}/${id}/payment_responsibilities`, {
      responsibilities,
    });
  }

  confirmPayment(id, responsibilityId, payload) {
    return axios.post(
      `${this.url}/${id}/payment_responsibilities/${responsibilityId}/confirmation`,
      payload
    );
  }

  uploadBoleto(id, responsibilityId, file, onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${this.url}/${id}/payment_responsibilities/${responsibilityId}/boleto`,
      formData,
      { onUploadProgress }
    );
  }

  updateBoleto(id, responsibilityId, payload) {
    return axios.patch(
      `${this.url}/${id}/payment_responsibilities/${responsibilityId}/boleto`,
      payload
    );
  }

  removeBoleto(id, responsibilityId) {
    return axios.delete(
      `${this.url}/${id}/payment_responsibilities/${responsibilityId}/boleto`
    );
  }

  downloadBoleto(id, responsibilityId) {
    return axios.get(
      `${this.url}/${id}/payment_responsibilities/${responsibilityId}/boleto`
    );
  }

  releaseSplit(id, beneficiaryId, beneficiaryType = 'usuario') {
    const path =
      beneficiaryType === 'usuario'
        ? `beneficiaries/${beneficiaryId}/release`
        : `beneficiaries/${beneficiaryType}/${beneficiaryId}/release`;
    return axios.post(`${this.url}/${id}/${path}`);
  }
}

export default new RealEstateFinanceAPI();
